module.exports = __webpack_public_path__ + "img/music-promotion-optimization.b1488b15.jpg";